/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IMoeGoogleAnalyticsScriptsViewProps } from './moe-google-analytics-scripts';

export default (props: IMoeGoogleAnalyticsScriptsViewProps) => {
    return (
        <div className='gogleAnalytics-scripts-wrap'>
            <div className='gogleAnalytics-scripts'></div>
        </div>
    );
};
